export const AnalyticsEventAction = {
  ADD_EXPLORE_COLUMN: 'add_explore_column',
  ADD_REPORT_FILTERS: 'add_report_filters',
  ADD_WIDGET: 'add_widget',
  ASSIGNMENT_UNASSIGNED: 'assignment_unassigned',
  ASSIGNMENT_UNIGNORED: 'assignment_unignored',
  BATCH_DELETE_REPORTS: 'batch_delete_reports',
  COLLAPSE_REPORT_SECTION: 'collapse_report_section',
  CONFIRM_PREDICTION: 'confirm_prediction',
  COPY_REPORT_SHARE_LINK: 'copy_report_share_link',
  CREATE_PHASE: 'create_phase',
  CREATE_PHASE_TYPE: 'create_phase_type',
  CREATE_PLAYER_GROUP: 'create_player_group',
  CREATE_PRESET: 'create_preset',
  CREATE_REPORT: 'create_report',
  CREATE_REPORT_BOOKMARK: 'create_report_bookmark',
  CREATE_REPORT_FROM_TEMPLATE: 'create_report_from_template',
  CREATE_REPORT_SHARE_LINK: 'create_report_share_link',
  DECLINE_PREDICTION: 'decline_prediction',
  DELETE_PHASE_TYPE: 'delete_phase_type',
  DELETE_PLAYER_GROUP: 'delete_player_group',
  DELETE_REPORT: 'delete_report',
  DELETE_REPORTS: 'delete_reports',
  DELETE_REPORT_BOOKMARK: 'delete_report_bookmark',
  DELETE_REPORT_FILTERS: 'delete_report_filters',
  DELETE_REPORT_SHARE_LINK: 'delete_report_share_link',
  DELETE_SESSION: 'delete_session',
  DELETE_UPLOAD: 'delete_upload',
  DELETE_WIDGET: 'delete_widget',
  DOWNLOAD_REPORT: 'download_report',
  DUPLICATE_REPORT: 'duplicate_report',
  EXPAND_REPORT_SECTION: 'expand_report_section',
  EXPORT_EVENTS_CSV: 'export_events_csv',
  EXPORT_ROSTER: 'export_roster',
  EXPORT_SHOT_STATS: 'export_shot_stats',
  EXPORT_STATISTICS_CSV: 'export_statistics_csv',
  IGNORE_ASSIGNMENT_INDIVIDUAL: 'ignore_assignment_individual',
  IGNORE_ASSIGNMENT_MANY: 'ignore_assignment_many',
  IGNORE_ASSIGNMENTS_WITHOUT_SHOTS: 'ignore_assignments_without_shots',
  IGNORE_ASSIGNMENTS_WITH_LESS_THAN_3_SHOTS: 'ignore_assignments_with_less_than_3_shots',
  IGNORE_ASSIGNMENTS_WITH_LESS_THAN_10_SECONDS: 'ignore_assignments_with_less_than_10_seconds',
  IGNORE_ASSIGNMENTS_WITH_LESS_THAN_1_MINUTE: 'ignore_assignments_with_less_than_1_minute',
  IGNORE_ASSIGNMENTS_WITH_LESS_THAN_3_MINUTES: 'ignore_assignments_with_less_than_3_minutes',
  MARK_AS_READ: 'mark_as_read',
  MARK_AS_UNREAD: 'mark_as_unread',
  SELECT_AREA_MAP: 'select_area_map',
  SELECT_CALENDAR_WEEK: 'select_calendar_week',
  SELECT_CONTEXT: 'select_context',
  SELECT_COURT_AREAS: 'select_court_areas',
  SELECT_INTENSITY_METRIC: 'select_intensity_metric',
  SELECT_PHASE_TYPES: 'select_phase_types',
  SELECT_PLAYER: 'select_player',
  SELECT_PLAYER_OVERVIEW_METRIC: 'select_player_overview_metric',
  SELECT_PLAYER_REFERENCE: 'select_player_reference',
  SELECT_PLAYERS: 'select_players',
  SELECT_PRESET: 'select_preset',
  SELECT_RANKING_METRIC: 'select_ranking_metric',
  SELECT_REPORT_BOOKMARK: 'select_report_bookmark',
  SELECT_SCOPE: 'select_scope',
  SELECT_SESSION: 'select_session',
  SELECT_SESSION_TYPES: 'select_session_types',
  SELECT_SHOT_LOAD: 'select_shot_load',
  SELECT_SHOT_RESULT: 'select_shot_result',
  SELECT_SHOT_TRENDS_METRIC: 'select_shot_trends_metric',
  SELECT_STATISTICS_SUMMARY_GROUP: 'select_statistics_summary_group',
  SELECT_TIME_RANGE: 'select_time_range',
  SHARE_REPORT: 'share_report',
  SPLIT_TRACK: 'split_track',
  SPLIT_TRACK_NOT_POSSIBLE: 'split_track_not_possible',
  TOGGLE_EXPLORE_COLUMN_EDITOR: 'toggle_explore_column_editor',
  UPDATE_EXPLORE_EVENTS_FILTERS: 'update_explore_events_filters',
  UPDATE_EXPLORE_STATISTICS_FILTERS: 'update_explore_statistics_filters',
  UPDATE_PLAYER_GROUP: 'update_player_group',
  UPDATE_REPORT: 'update_report',
  UPDATE_REPORT_FILTERS: 'update_report_filters',
  UPDATE_REPORT_USER_ACCESS: 'update_report_user_access',
  UPDATE_SESSION: 'update_session',
  UPDATE_WIDGET_OPTIONS: 'update_widget_options',
  VIEW_ENTRY: 'view_entry',
  VIEW_PLAYER_STATS: 'view_player_stats',
} as const;
